<template>
  <v-app :class="{ watermark: isStaging }">
    <v-app-bar
      app
      dark
      :clipped-left="clipped"
      color="primary"
      :class="{ watermarksm: isStaging }"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Vonex Commissions</v-toolbar-title>

      <div class="flex-grow-1"></div>
      <div>
        <img
          src="@/assets/images/vonexLogo.png"
          height="54px"
          alt="smallLogo"
          style="padding: 9px; margin:5px 0 0"
        />
      </div>

      <v-spacer></v-spacer>
      <v-btn v-if="!isAuthenticated" small to="/login">Login</v-btn>
      <v-col class="shrink" v-if="isAuthenticated && userProfile">
        <span
          class="text-muted font-weight-light px-2"
          style="color: #fff !important;"
        >
          {{ userProfile.name }}
        </span>
        <v-btn
          small
          color="danger"
          v-if="isAuthenticated"
          v-on:click="logout()"
        >
          Logout
        </v-btn>
      </v-col>
    </v-app-bar>

    <v-navigation-drawer
      :clipped="clipped"
      v-model="drawer"
      :disable-resize-watcher="false"
      app
      floating
      persistent
      mobile-break-point="991"
      width="260"
    >
      <v-list-item @click="navigate('/')">
        <v-list-item-icon>
          <v-icon>home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Start</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list dense nav>
        <v-list-group
          v-for="(item, index) in items.filter((y) =>
            dealer.authLevel !== 'Employee'
              ? true
              : y.security == dealer.authLevel,
          )"
          :key="index"
          @click="navigate(item.route)"
          :prepend-icon="item.icon"
          no-action
        >
          <v-list-item slot="activator">
            <v-list-item-content>
              <span>{{ item.title }}</span>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-for="(subItem, i) in item.subMenu"
            :key="i"
            @click="navigate(subItem.route)"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ subItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <v-dialog
        v-model="mfadialog"
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <mfa-dialog @closeDialog="closeMFADialog"></mfa-dialog>
      </v-dialog>
      <v-container class="fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <router-view
              :isAuthenticated="isAuthenticated"
              :userProfile="userProfile"
            />
            <message-alert></message-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; 2018 Copyright: vonex.com.au</span>
    </v-footer>
  </v-app>
</template>

<script>
import Vue from 'vue'
import AppTitle from '@/components/app-title.vue'
import MessageAlert from '@/components/MessageAlert'
import MfaDialog from '@/components/EnrollMFADialog.vue'
import { createNamespacedHelpers } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import AppAlert from '@/components/app-alert'
import items from '@/components/menuItems'
import moment from 'moment'
import VeeValidate from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

Vue.component('date-picker', DatePicker)
Vue.component('mfa-dialog', MfaDialog)

Vue.use(VuejsDialog)
Vue.use(VeeValidate)
Vue.component('app-alert', AppAlert)
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})
Vue.filter('orderStatus', function (value) {
  switch (value) {
    case 0:
      return 'New'
    case 1:
      return 'In Progress'
    case 2:
      return 'Signed'
    case 3:
      return 'Completed'
    case 4:
      return 'Cancelled'
    case 5:
      return 'Rejected'
    default:
      return 'Unknown'
  }
})
Vue.filter('formatMoney', function (n) {
  let ans = Math.abs(n * 100) / 100
  return Math.abs(ans).toFixed(2)
})

const {
  mapGetters: mapAuthGetters,
  mapActions: mapAuthActions,
} = createNamespacedHelpers(`auth`)

const { mapState: mapDealerState } = createNamespacedHelpers(`dealer`)

export const { mapFields: mapAuthFields } = createHelpers({
  getterType: `auth/getField`,
  mutationType: `auth/updateField`,
})

Vue.component('app-title', AppTitle)
Vue.component('message-alert', MessageAlert)
export default {
  name: 'DealerPortal',
  data() {
    return {
      clipped: true,
      drawer: null,
      fixed: false,
      items: items.items,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Sign On Glass Partner Administration',
      responsive: false,
      responsiveInput: false,
      mfadialog: false,
    }
  },
  methods: {
    ...mapAuthActions(['login', 'logout']),
    navigate: function (route) {
      this.$router.push(route)
    },
    openMFADialog() {
      this.mfadialog = true
    },
    closeMFADialog() {
      this.mfadialog = false
    },
  },
  computed: {
    ...mapAuthFields(['token', 'userProfile']),
    ...mapDealerState(['dealer']),
    ...mapAuthGetters(['isAuthenticated']),
    isStaging() {
      return (
        process.env.NODE_ENV == 'staging' ||
        process.env.NODE_ENV == 'development'
      )
    },
  },
}
</script>
<style>
.dg-container {
  font-family: Roboto, sans-serif;
}

.dg-btn-loader .dg-circle {
  background-color: green;
}
.watermark {
  background: url('https://vonex.com.au/vonex/projects/watermark-blck.png')
    repeat !important;
}
.watermarksm {
  background: url('https://vonex.com.au/vonex/projects/watermark-small.png')
    repeat !important;
}
</style>
